import React from "react";
import { Link } from "react-router-dom";
import UserName from "components/common/UserName";

const SurveyTableRow = ({
  survey: { id, title, creator, points, responseCount, surveyItems },
  children,
  editable
}) => (
  <tr className="SurveyTableRow">
    <td className="SurveyTableRow__title">
      {editable && <Link to={`/surveys/${id}/edit`}>{title}</Link>}
      {!editable && <span>{title}</span>}
    </td>
    <td>
      <UserName user={creator} />
    </td>
    <td>{points}</td>
    <td>{surveyItems.length}</td>
    <td>{responseCount || 0}</td>
    {children}
  </tr>
);

export default SurveyTableRow;
